/**
 * 統一的錯誤類型定義
 * 所有錯誤都應遵循此格式
 */

/**
 * API 錯誤碼枚舉
 */
export enum ApiErrorCode {
  // 認證相關錯誤 (401xxx)
  UNAUTHORIZED = 'UNAUTHORIZED',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  TOKEN_INVALID = 'TOKEN_INVALID',
  LOGIN_FAILED = 'LOGIN_FAILED',
  
  // 權限相關錯誤 (403xxx)
  FORBIDDEN = 'FORBIDDEN',
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  
  // 資源相關錯誤 (404xxx)
  NOT_FOUND = 'NOT_FOUND',
  RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND',
  QUERY_NOTFOUND = 'QUERY_NOTFOUND',
  
  // 驗證相關錯誤 (400xxx)
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_PARAMS = 'INVALID_PARAMS',
  INVALID_REQUEST = 'INVALID_REQUEST',
  
  // 業務邏輯錯誤 (409xxx)
  CONFLICT = 'CONFLICT',
  DUPLICATE_ENTRY = 'DUPLICATE_ENTRY',
  OPERATION_CONFLICT = 'OPERATION_CONFLICT',
  
  // 服務器錯誤 (500xxx)
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  DATABASE_ERROR = 'DATABASE_ERROR',
  
  // 網絡錯誤
  NETWORK_ERROR = 'NETWORK_ERROR',
  TIMEOUT = 'TIMEOUT',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
}

/**
 * API 錯誤狀態碼映射
 */
export const ApiErrorStatusMap: Record<ApiErrorCode, number> = {
  [ApiErrorCode.UNAUTHORIZED]: 401001,
  [ApiErrorCode.TOKEN_EXPIRED]: 401002,
  [ApiErrorCode.TOKEN_INVALID]: 401003,
  [ApiErrorCode.LOGIN_FAILED]: 401004,
  [ApiErrorCode.FORBIDDEN]: 403001,
  [ApiErrorCode.INSUFFICIENT_PERMISSIONS]: 403002,
  [ApiErrorCode.NOT_FOUND]: 404001,
  [ApiErrorCode.RESOURCE_NOT_FOUND]: 404002,
  [ApiErrorCode.QUERY_NOTFOUND]: 500002,
  [ApiErrorCode.VALIDATION_ERROR]: 400001,
  [ApiErrorCode.INVALID_PARAMS]: 400002,
  [ApiErrorCode.INVALID_REQUEST]: 400003,
  [ApiErrorCode.CONFLICT]: 409001,
  [ApiErrorCode.DUPLICATE_ENTRY]: 409002,
  [ApiErrorCode.OPERATION_CONFLICT]: 409003,
  [ApiErrorCode.INTERNAL_ERROR]: 500001,
  [ApiErrorCode.SERVER_ERROR]: 500002,
  [ApiErrorCode.DATABASE_ERROR]: 500003,
  [ApiErrorCode.NETWORK_ERROR]: 0,
  [ApiErrorCode.TIMEOUT]: 0,
  [ApiErrorCode.CONNECTION_ERROR]: 0,
};

/**
 * API 錯誤接口
 */
export interface IApiError {
  code: ApiErrorCode | string;
  status: number;
  message: string;
  details?: unknown;
  timestamp?: string;
}

/**
 * RTK Query 錯誤格式
 */
export interface IRtkQueryError {
  status?: number;
  data?: {
    success?: boolean;
    status?: number;
    code?: string;
    msg?: string;
    message?: string;
    data?: unknown;
  };
  error?: string;
  message?: string;
}

/**
 * 錯誤處理結果
 */
export interface IErrorHandleResult {
  shouldRetry: boolean;
  shouldLogout: boolean;
  userMessage: string;
  logMessage: string;
}

